/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { bool, func } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Image } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';

import useNotification from '@hooks/notification/useNotification';

import ImgNotifAkun from 'Image/Notification/notif_akun.png';
import ImgNotifInvest from 'Image/Notification/notif_invest.png';
import ImgNotifPromo from 'Image/Notification/notif_promo.png';
import ImgNotifSaving from 'Image/Notification/notif_saving.png';
import ImgNotifMaintenance from 'Image/Notification/notif_maintenance.png';

import { Text } from 'Component/Ajaib';
import { Button, Pills, Separator, colors } from '@ajaibid/components';
import { SkeletonLoad } from 'Component/Skeleton';

import { onDoRequestListNotification, onDoRequestReadNotification } from 'Redux/notification';
import { N50, N900 } from '@assets/colors';
import { formatDate, noop } from '@ajaibid/utils';
import IconNotifNotfound from '@assets/Image/Notification/notif_notfound';
import styles from './style';

function NotificationMenu(props) {
  const { notifActive, setNotifActive } = props;
  const { fetchNotifCategory, notifCategory } = useNotification();

  useEffect(() => {
    fetchNotifCategory();
  }, []);

  const dispatch = useDispatch();

  const [pageNotif, setPageNotif] = useState(1);

  const notifData = useSelector((state) => state.notification.listNotificationData);
  const notifError = useSelector((state) => state.notification.listNotificationError);
  const notif = notifData?.result;
  const resultNotif = notifData?.result?.results || [];
  const notifLoading = useSelector((state) => state.notification.listNotificationLoading);

  const ctaData = useSelector((state) => state.notification.listCtaData);
  const ctaLoading = useSelector((state) => state.notification.listCtaLoading);

  const unreadData = useSelector((state) => state.notification.unreadNotifData);
  const unreadNotifLoading = useSelector((state) => state.notification.unreadNotifLoading);
  const unread = unreadData?.result?.count;

  const [subMenuActive, setSubMenuActive] = useState('activity');
  const [selectedCategory, setSelectedCategory] = useState(null);

  const hasMore = !!notif?.next;
  const handleUpdateScrollbarsNotif = useCallback((values) => {
    const { scrollTop, scrollHeight, clientHeight } = values;

    const pad = 100; // 100px of the bottom
    // t will be greater than 1 if we are about to reach the bottom
    const t = (scrollTop + pad) / (scrollHeight - clientHeight);
    if (t > 1 && hasMore && !notifLoading) {
      setPageNotif(pageNotif + 1);
    }
  });

  const handleCategoryClick = (category) => {
    setSelectedCategory((prevCategory) => (prevCategory === category ? null : category));
    setPageNotif(1);
  };

  useEffect(() => {
    const queryParams = `?page=${pageNotif}&page_size=10${
      selectedCategory ? `&category_code=${selectedCategory}` : ''
    }`;
    dispatch(onDoRequestListNotification(queryParams, pageNotif === 1));
  }, [pageNotif, selectedCategory]);

  const readNotifData = useSelector((state) => state.notification.readNotifData);

  useEffect(() => {
    if (readNotifData && readNotifData.errCode === 'EC0000000') {
      dispatch(onDoRequestListNotification(`?page=${pageNotif}&page_size=20`, pageNotif === 1));
    }
  }, [readNotifData]);

  const notificationsByDate = resultNotif.reduce((acc, curr) => {
    const date = new Date(curr.created_at);
    const dateString = date.toDateString();
    if (selectedCategory && selectedCategory !== curr.category_code) {
      return acc;
    }
    if (!acc[dateString]) {
      acc[dateString] = [];
    }
    acc[dateString].push(curr);
    return acc;
  }, {});

  const categoryImages = {
    AKUN: ImgNotifAkun,
    PROMOSI: ImgNotifPromo,
    INVESTASI: ImgNotifInvest,
    BANK: ImgNotifSaving,
  };

  const handleReadAllClick = () => {
    dispatch(onDoRequestReadNotification());
  };

  return (
    <div>
      <div style={styles.containerTopLabel}>
        <div style={styles.topLabel}>Pesan</div>
        <Button variant="naked" onClick={handleReadAllClick}>
          {' '}
          Tandai Dibaca Semua
        </Button>
      </div>
      <Row className="profile-content pl-16 pr-16 pt-16 m-0">
        <Col
          className={`text-center tab-level-1-big ${subMenuActive === 'activity' ? 'active' : ''}`}
          onClick={() => setSubMenuActive('activity')}
        >
          Kotak Masuk
          {!unreadNotifLoading && unread !== 0 && <div style={styles.alertNotif} />}
        </Col>
        <Col
          className={`text-center tab-level-1-big ${subMenuActive === 'promo' ? 'active' : ''}`}
          onClick={() => setSubMenuActive('promo')}
        >
          Pengumuman
          {ctaData && ctaData.length > 0 && <div style={styles.alertNotif} />}
        </Col>
      </Row>
      <Row className="m-0">
        <Col className="p-0">
          <Separator color={N50} top={0} bottom={8} />
        </Col>
      </Row>
      {subMenuActive === 'promo' ? (
        <Scrollbars style={styles.menuCtaContent} autoHide>
          <Row className="m-0">
            <Col className="p-0">
              <>
                {ctaLoading && !ctaData && (
                  <>
                    <Row className="p-16 m-0">
                      <Col className="p-0">
                        <SkeletonLoad height={50} />
                      </Col>
                    </Row>
                    <Row className="pl-16 pr-16 m-0">
                      <Col className="p-0">
                        <Separator color={N50} top={12} bottom={12} />
                      </Col>
                    </Row>
                    <Row className="pl-16 pr-16 pb-16 m-0">
                      <Col className="p-0">
                        <SkeletonLoad height={50} />
                      </Col>
                    </Row>
                    <Row className="pl-16 pr-16 m-0">
                      <Col className="p-0">
                        <Separator color={N50} top={12} bottom={12} />
                      </Col>
                    </Row>
                  </>
                )}
                {((ctaData && ctaData.length === 0) || ctaData === null) && (
                  <Row className="p-16 m-0" style={{ height: 'calc(100vh - 500px)' }}>
                    <Col className="p-0 d-flex align-items-center">
                      <div className="p-16 text-center">
                        <IconNotifNotfound />
                        <div>
                          <Text size="body-bold" color="black">
                            Belum ada Pesan di Pengumuman
                          </Text>
                        </div>
                        <div>
                          <Text color="grey">
                            Kamu bisa melihat pesan yang masuk pada layar ini.
                          </Text>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                {ctaData &&
                  ctaData.length !== 0 &&
                  typeof ctaData !== 'string' &&
                  ctaData?.map((v) => (
                    <Row
                      key={v.id}
                      className="p-16 m-0 d-flex align-items-center"
                      onClick={() => {
                        window.location.href = v.web_action;
                        setNotifActive(false);
                      }}
                      style={{
                        backgroundColor: v?.background_color || colors.NEUTRAL_0,
                        backgroundImage: v?.background_image,
                        cursor: 'pointer',
                      }}
                    >
                      <Col lg={4} md={4} className="p-0" style={{ marginLeft: -7 }}>
                        <div style={styles.notifContainer}>
                          <div
                            style={{
                              width: 80,
                              height: 80,
                              borderRadius: 4,
                              overflow: 'hidden',
                              margin: 'auto',
                            }}
                          >
                            <Image
                              src={v.image}
                              alt=""
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col lg={8} md={8} className="ml-1 p-0">
                        <div style={{ color: v?.color || colors.NEUTRAL_10 }}>
                          <Text bold size="body-bold">
                            {v.title}
                          </Text>
                          <div className="mt-8">
                            <Text>{v.description}</Text>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ))}
              </>
            </Col>
          </Row>
        </Scrollbars>
      ) : (
        <>
          <Row className="pl-16 pr-16 pt-16 pb-8 m-0">
            <Col className="d-flex p-0" style={{ overflow: 'scroll' }}>
              {notifCategory?.map((category) => (
                <Pills
                  key={category.category_code}
                  className="m-4 cursor-pointer"
                  active={selectedCategory === category.category_code}
                  onClick={() => handleCategoryClick(category.category_code)}
                >
                  {category.category_name}
                </Pills>
              ))}
            </Col>
          </Row>
          {notifData?.result.length && notifError && (
            <Row className="p-16 m-0" style={{ height: 'calc(100vh - 323px)' }}>
              <Col className="p-0 d-flex align-items-center">
                <div className="p-16 text-center">
                  <Image src={ImgNotifMaintenance} style={{ width: 100, height: 80 }} />
                  <div>
                    <Text color="black">Sistem Sedang dalam Pemeliharaan</Text>
                  </div>
                </div>
              </Col>
            </Row>
          )}

          {Object.keys(notificationsByDate).length > 0 ? (
            <Scrollbars
              style={styles.menuNotifContent}
              autoHide
              onUpdate={handleUpdateScrollbarsNotif}
            >
              <Row className="m-0">
                <Col className="p-0">
                  <div>
                    {Object.keys(notificationsByDate)?.map((date) => (
                      <div key={date} style={{ cursor: 'pointer' }}>
                        <div
                          className="pl-16 pr-16 pt-16"
                          style={{ fontSize: 16, color: N900, fontWeight: 700 }}
                        >
                          {new Date(date).toDateString() === new Date().toDateString() ? (
                            <span>Hari Ini</span>
                          ) : (
                            <span style={{ fontSize: '14' }}>
                              {date && formatDate(date, 'dddd, DD MMM YYYY')}
                            </span>
                          )}
                        </div>
                        {notificationsByDate[date]?.map((notification) => (
                          <div
                            key={notification.id}
                            className="list-notif"
                            style={{
                              background: !notification.is_read && '#E1F2FA',
                              marginLeft: 16,
                              marginRight: 16,
                              marginBottom: 2,
                              borderRadius: 12,
                              padding: 12,
                            }}
                            onClick={() => {
                              if (notification.is_read === false) {
                                window.location.href = notification.cta_web;
                              } else {
                                window.location.href = notification.cta_web;
                              }
                            }}
                          >
                            <Row className="m-0 ">
                              <div className="d-flex justify-content-between">
                                <img
                                  src={categoryImages[notification.category_code] || ImgNotifAkun}
                                  alt=""
                                  style={{ width: 40, height: 40 }}
                                />
                                <div>
                                  <Col lg={12} md={12} className="p-0">
                                    <div
                                      size="label-regular"
                                      className="d-flex justify-content-between"
                                    >
                                      <div className="d-flex flex-column" style={{ width: '75%' }}>
                                        <b
                                          style={{
                                            fontColor: colors.NEUTRAL_10,
                                            maxWidth: 190,
                                            paddingLeft: 4,
                                            marginBottom: 4,
                                            fontSize: 14,
                                            fontWeight: 700,
                                            lineHeight: '20px',
                                          }}
                                        >
                                          {notification.message_title}
                                        </b>
                                      </div>
                                      <div style={{ fontWeight: 400 }}>
                                        <span style={{ fontSize: 10, color: colors.NEUTRAL_7 }}>
                                          {notification?.created_at &&
                                            formatDate(notification?.created_at, 'HH:mm')}
                                        </span>{' '}
                                        <span style={{ fontSize: 10, color: colors.NEUTRAL_7 }}>
                                          WIB
                                        </span>
                                      </div>
                                    </div>
                                    <div style={{ paddingLeft: 4 }}>
                                      <span
                                        size="label-regular"
                                        style={{
                                          fontColor: colors.NEUTRAL_7,
                                          fontWeight: 400,
                                          fontSize: '12px',

                                          marginTop: 0,
                                          paddingTop: 0,
                                        }}
                                      >
                                        {notification.message_body}
                                      </span>
                                    </div>
                                  </Col>
                                </div>
                              </div>
                            </Row>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
              {(hasMore || notifLoading || unreadNotifLoading || ctaLoading) && (
                <>
                  <Row className="p-16 m-0">
                    <Col className="p-0">
                      <SkeletonLoad height={50} />
                    </Col>
                  </Row>
                  <Row className="pl-16 pr-16 m-0">
                    <Col className="p-0">
                      <Separator color={N50} top={12} bottom={12} />
                    </Col>
                  </Row>
                  <Row className="pl-16 pr-16 pb-16 m-0">
                    <Col className="p-0">
                      <SkeletonLoad height={50} />
                    </Col>
                  </Row>
                  <Row className="pl-16 pr-16 m-0">
                    <Col className="p-0">
                      <Separator color={N50} top={12} bottom={12} />
                    </Col>
                  </Row>
                </>
              )}
            </Scrollbars>
          ) : (
            !notifLoading &&
            !unreadNotifLoading &&
            !ctaLoading && (
              <Row className="p-16 m-0" style={{ height: 'calc(100vh - 323px)' }}>
                <Col className="p-0 d-flex align-items-center">
                  <div className="p-16 text-center">
                    <IconNotifNotfound />
                    <div>
                      <Text size="body-bold" color="black">
                        Belum ada Pesan di Kotak Masuk
                      </Text>
                    </div>
                    <div>
                      <Text color="grey">Kamu bisa melihat pesan yang masuk pada layar ini.</Text>
                    </div>
                  </div>
                </Col>
              </Row>
            )
          )}
        </>
      )}
    </div>
  );
}

NotificationMenu.propTypes = {
  notifActive: bool,
  setNotifActive: func,
};

NotificationMenu.defaultProps = {
  notifActive: false,
  setNotifActive: noop,
};
export default NotificationMenu;
